import { defaultStatusColor, statusColorMap } from "./Constant";
import { ExecutionStatus, StatusColor } from "./Types";

/**
 * This function returns the color and text color for the status
 * @param status the status of the execution
 * @returns the color and text color for the status
 */
export const getStatusColors = (status: ExecutionStatus): StatusColor => {
  return statusColorMap[status] || defaultStatusColor;
};
